import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private requestCount = 0;
  private readonly _isLoading = signal(false);

  readonly isLoading = this._isLoading.asReadonly();

  show(): void {
    this.requestCount += 1;
    this._isLoading.set(true);
  }

  hide(): void {
    this.requestCount = Math.max(0, this.requestCount - 1);

    if (this.requestCount === 0) {
      this._isLoading.set(false);
    }
  }
}
